<!-- TODO: form 整合到一起 -->

<template>
  <div class="page">
    <div class="c-source-form">
      <el-form inline>
        <div class="content">
          <el-form-item label="属性名">
            <el-input v-model="data.name"></el-input>
          </el-form-item>
          <div class="form-group-wrap">
            <div class="form-group" v-for="(item, index) in data.property_values_attributes" :key="'属性值_' + index">
              <el-form-item label="属性值">
                <el-input v-model="data.property_values_attributes[index].value"></el-input>
              </el-form-item>
              <el-color-picker v-if="data.name === '颜色'"></el-color-picker>
              <el-button type="text" @click="handleRemoveValue(index)">删除</el-button>
            </div>
          </div>
          <el-form-item class="btn-group">
            <el-button type="primary" @click="handleAddValue">添加属性</el-button>
          </el-form-item>
        </div>
        <el-form-item class="btn-group">
          <el-button type="primary" @click="onSubmit">创建</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class PropertynamesNew extends Vue {

  data = {
    name: '',
    property_values_attributes: [{
      value: ''
    }]
  }

  async onSubmit() {
    const res = await this.$autoLoading(
      this.$request.post('/property_names/', this.data)
    );
    this.$message.success('创建规格成功');
    this.$router.push({ name: 'property_names.show', params: { id: res.id } });
  }

  handleRemoveValue(index) {
    this.data.property_values_attributes.splice(index, 1);
  }

  handleAddValue() {
    this.data.property_values_attributes.push({ value: '' });
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .c-source-form .form-group-wrap {
    width: 700px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .form-group {
      width: 50%;
    }
  }
</style>
